/**
 * Canonical promise-based sleep — resolve after `ms` milliseconds.
 *
 * Deliberately guard-free (no `server-only`, zero imports) so it is safe to
 * use from client components, API routes, workflows, AND `convex/` actions —
 * the Convex bundler breaks on any module graph that reaches `server-only`,
 * and `lib/shared` must stay a leaf (see lib/shared/README.md).
 *
 * Variants that need more than a plain delay intentionally stay local to
 * their call sites: abortable (lib/shared/async/poll-until-settled.ts),
 * injectable-for-tests (lib/core/rate-limit/distributed-token-bucket.ts),
 * jittered (lib/rendering/email-screenshot.ts), and the schedule-aware
 * `sleepUntilScheduledAt` helpers in the send/automation workflows.
 */
export function sleep(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms))
}
